// import { yupResolver } from '@hookform/resolvers/yup';
// import {
//   Alert,
//   Avatar,
//   Box,
//   Button,
//   CircularProgress,
//   Divider,
//   FormControl,
//   FormControlLabel,
//   Grid,
//   IconButton,
//   InputAdornment,
//   Paper,
//   Radio,
//   RadioGroup,
//   TextField,
//   Typography,
//   useMediaQuery,
//   useTheme
// } from '@mui/material';
// import { AppDispatch, RootState } from 'app/store';
// import React, { useEffect, useRef, useState } from 'react';
// import { Controller, useForm } from 'react-hook-form';
// import {
//   FaCalendarAlt,
//   FaCamera,
//   FaClock,
//   FaDatabase,
//   FaExclamationTriangle,
//   FaFileAlt,
//   FaMapMarkerAlt,
//   FaShieldAlt,
//   FaSignature,
//   FaUndo,
//   FaUserCircle
// } from 'react-icons/fa';
// import { FiArrowLeft, FiTrash } from 'react-icons/fi';
// import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
// import { useLocation, useNavigate } from 'react-router-dom';
// import { DataBreach } from 'slices/NdisSlices/carporateServices/IncidentsListSlice';
// import {
//   clearDataBreachState,
//   DataBreachFormData,
//   submitDataBreach
// } from 'slices/NdisSlices/reportAllForms/dataBreachSlice';
// import * as yup from 'yup';

// // Validation schemas
// const mainSchema = yup
//   .object({
//     id: yup.string().optional(),
//     date_of_incident: yup.string().required('Date of incident is required'),
//     time_of_incident: yup.string().required('Time of incident is required'),
//     location_of_incident: yup.string().required('Location is required'),
//     type_of_data: yup.string().required('Data type is required'),
//     other_type_of_data: yup.string().when('type_of_data', {
//       is: 'Other',
//       then: (schema) => schema.required('Please specify other data type'),
//       otherwise: (schema) => schema.optional().default('')
//     }),
//     description: yup.string().required('Description is required'),
//     individuals_affected: yup.string().required('Individuals affected is required'),
//     contact_info: yup.string().required('Contact information is required'),
//     immediate_actions: yup.string().required('Immediate actions taken is required'),
//     breach_reported_externally: yup.string().optional().default(''),
//     reported_to: yup.string().optional().default(''),
//     prevention_recommendations: yup.string().optional().default(''),
//     reporter_name: yup.string().required('Reporter name is required'),
//     signature: yup.string().required('Signature is required'),
//     date_completed: yup.string().required('Date completed is required'),
//     photo: yup.mixed<File>().optional().default(undefined),
//     client_email: yup.string().optional().default('')
//   })
//   .required();

// const followUpSchema = yup
//   .object({
//     id: yup.string().optional(),
//     date_of_incident: yup.string().optional().default(''),
//     time_of_incident: yup.string().optional().default(''),
//     location_of_incident: yup.string().optional().default(''),
//     type_of_data: yup.string().optional().default(''),
//     other_type_of_data: yup.string().optional().default(''),
//     description: yup.string().optional().default(''),
//     individuals_affected: yup.string().optional().default(''),
//     contact_info: yup.string().optional().default(''),
//     immediate_actions: yup.string().optional().default(''),
//     breach_reported_externally: yup.string().required('Please specify if reported externally'),
//     reported_to: yup.string().when('breach_reported_externally', {
//       is: 'Yes',
//       then: (schema) => schema.required('Please specify to whom it was reported'),
//       otherwise: (schema) => schema.optional().default('')
//     }),
//     resolved: yup
//       .string()
//       .oneOf(['Yes', 'No'], 'Please specify if the incident is resolved')
//       .required('Please specify if the incident is resolved'),
//     prevention_recommendations: yup
//       .string()
//       .required('Recommendations for prevention are required'),
//     reporter_name: yup.string().optional().default(''),
//     signature: yup.string().optional().default(''),
//     date_completed: yup.string().optional().default(''),
//     photo: yup.mixed<File>().optional().default(undefined),
//     client_email: yup.string().optional().default('')
//   })
//   .required();

// interface Props {
//   initialData?: DataBreach;
//   onClose?: () => void;
// }

// const DataBreachIncidentForm: React.FC<Props> = ({ initialData, onClose }) => {
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
//   const isLargeScreen = useMediaQuery(theme.breakpoints.up('lg'));
//   const dispatch = useDispatch<AppDispatch>();
//   const useTypedSelector: TypedUseSelectorHook<RootState> = useSelector;
//   const { message, loading, error } = useTypedSelector((state) => state.dataBreach);
//   const [photoPreview, setPhotoPreview] = useState<string | null>(null);
//   const fileInputRef = useRef<HTMLInputElement>(null);
//   const navigate = useNavigate();
//   const location = useLocation();

//   // Local storage data
//   const selectedClient = JSON.parse(localStorage.getItem('selectedClient') || '{}') as {
//     email?: string;
//   };

//   // Determine which form section to show
//   const searchParams = new URLSearchParams(location.search);
//   const tabParam = searchParams.get('tab') || 'incidents';
//   const incidentId = initialData?.id || undefined;

//   const isMainFormRoute = location.pathname === '/dataBreach-Incident';
//   const isFollowUpRoute =
//     location.pathname === '/ndis-operations/corporate-services' && tabParam === 'incidents';

//   // Check if Follow-Up form is already filled
//   const [alreadyFilled, setAlreadyFilled] = useState(false);
//   useEffect(() => {
//     if (isFollowUpRoute && initialData) {
//       const isFilled = [
//         initialData.breach_reported_externally,
//         initialData.reported_to,
//         initialData.prevention
//       ].some((field) => field !== undefined && field !== null && field !== '');
//       setAlreadyFilled(isFilled);
//     } else {
//       setAlreadyFilled(false);
//     }
//   }, [initialData, isFollowUpRoute]);

//   // Use separate useForm hooks for each route
//   const defaultDateTime = new Date().toISOString().split('T')[0];
//   const mainForm = useForm<DataBreachFormData>({
//     resolver: yupResolver(mainSchema) as any,
//     defaultValues: {
//       id: initialData?.id || '',
//       date_of_incident: initialData?.date || defaultDateTime,
//       time_of_incident: initialData?.time || '',
//       location_of_incident: initialData?.location || '',
//       type_of_data: initialData?.type_of_data || '',
//       other_type_of_data: initialData?.type_of_data === 'Other' ? initialData?.type_of_data : '',
//       description: initialData?.description || '',
//       individuals_affected: initialData?.individuals_affected || '',
//       contact_info: initialData?.contact_info || '',
//       immediate_actions: initialData?.immediate_actions || '',
//       breach_reported_externally: initialData?.breach_reported_externally || '',
//       reported_to: initialData?.reported_to || '',
//       prevention_recommendations: initialData?.prevention || '',
//       reporter_name: initialData?.reporter_name || '',
//       signature: initialData?.signature || '',
//       date_completed: initialData?.date_completed || defaultDateTime,
//       photo: undefined,
//       client_email: selectedClient?.email || ''
//     }
//   });

//   const followUpForm = useForm<DataBreachFormData>({
//     resolver: yupResolver(followUpSchema) as any,
//     defaultValues: {
//       id: initialData?.id || '',
//       date_of_incident: initialData?.date || '',
//       time_of_incident: initialData?.time || '',
//       location_of_incident: initialData?.location || '',
//       type_of_data: initialData?.type_of_data || '',
//       other_type_of_data: initialData?.type_of_data === 'Other' ? initialData?.type_of_data : '',
//       description: initialData?.description || '',
//       individuals_affected: initialData?.individuals_affected || '',
//       contact_info: initialData?.contact_info || '',
//       immediate_actions: initialData?.immediate_actions || '',
//       breach_reported_externally: initialData?.breach_reported_externally || '',
//       reported_to: initialData?.reported_to || '',
//       prevention_recommendations: initialData?.prevention || '',
//       reporter_name: initialData?.reporter_name || '',
//       signature: initialData?.signature || '',
//       date_completed: initialData?.date_completed || defaultDateTime,
//       photo: undefined,
//       client_email: selectedClient?.email || '',
//       resolved: initialData?.resolved || ''
//     }
//   });

//   const type_of_data = isMainFormRoute
//     ? mainForm.watch('type_of_data')
//     : followUpForm.watch('type_of_data');
//   const breach_reported_externally = isMainFormRoute
//     ? mainForm.watch('breach_reported_externally')
//     : followUpForm.watch('breach_reported_externally');

//   const handlePhotoChange = (
//     e: React.ChangeEvent<HTMLInputElement>,
//     onChange: (value: File | undefined) => void
//   ) => {
//     const file = e.target.files?.[0];
//     if (file) {
//       onChange(file);
//       const reader = new FileReader();
//       reader.onloadend = () => {
//         setPhotoPreview(reader.result as string);
//       };
//       reader.readAsDataURL(file);
//     } else {
//       setPhotoPreview(null);
//       onChange(undefined);
//     }
//   };

//   const handleRemovePhoto = () => {
//     setPhotoPreview(null);
//     if (isMainFormRoute) {
//       mainForm.setValue('photo', undefined, { shouldValidate: true });
//     } else {
//       followUpForm.setValue('photo', undefined, { shouldValidate: true });
//     }
//     if (fileInputRef.current) {
//       fileInputRef.current.value = '';
//     }
//   };

//   const onSubmitMain = (data: DataBreachFormData) => {
//     const payload: DataBreachFormData = {
//       ...data,
//       client_email: selectedClient.email || data.client_email
//     };

//     dispatch(submitDataBreach(payload)).then(() => {
//       mainForm.reset();
//       setPhotoPreview(null);
//       if (fileInputRef.current) {
//         fileInputRef.current.value = '';
//       }
//       setTimeout(() => dispatch(clearDataBreachState()), 5000);
//     });
//   };

//   const onSubmitFollowUp = (data: DataBreachFormData) => {
//     const payload: DataBreachFormData = {
//       id: incidentId || initialData?.id,
//       date_of_incident: initialData?.date || data.date_of_incident,
//       time_of_incident: initialData?.time || data.time_of_incident,
//       location_of_incident: initialData?.location || data.location_of_incident,
//       type_of_data: initialData?.type_of_data || data.type_of_data,
//       other_type_of_data:
//         initialData?.type_of_data === 'Other'
//           ? initialData?.type_of_data
//           : data.type_of_data === 'Other'
//           ? data.other_type_of_data
//           : '',
//       description: initialData?.description || data.description,
//       individuals_affected: initialData?.individuals_affected || data.individuals_affected,
//       contact_info: initialData?.contact_info || data.contact_info,
//       immediate_actions: initialData?.immediate_actions || data.immediate_actions,
//       breach_reported_externally: data.breach_reported_externally,
//       reported_to: data.reported_to,
//       prevention_recommendations: data.prevention_recommendations,
//       reporter_name: initialData?.reporter_name || data.reporter_name,
//       signature: initialData?.signature || data.signature,
//       date_completed: initialData?.date_completed || data.date_completed,
//       photo: initialData?.photo || '',
//       client_email: selectedClient.email || data.client_email,
//       resolved: data.resolved
//     };

//     dispatch(submitDataBreach(payload)).then(() => {
//       followUpForm.reset();
//       setPhotoPreview(null);
//       if (fileInputRef.current) {
//         fileInputRef.current.value = '';
//       }
//       setTimeout(() => dispatch(clearDataBreachState()), 5000);
//       if (onClose) {
//         onClose();
//       }
//     });
//   };

//   const handleResetMain = (e: React.MouseEvent<HTMLButtonElement>) => {
//     e.preventDefault();
//     mainForm.reset();
//     setPhotoPreview(null);
//     if (fileInputRef.current) {
//       fileInputRef.current.value = '';
//     }
//     dispatch(clearDataBreachState());
//   };

//   const handleResetFollowUp = (e: React.MouseEvent<HTMLButtonElement>) => {
//     e.preventDefault();
//     followUpForm.reset();
//     setPhotoPreview(null);
//     if (fileInputRef.current) {
//       fileInputRef.current.value = '';
//     }
//     dispatch(clearDataBreachState());
//   };

//   useEffect(() => {
//     window.scrollTo({ top: 0, behavior: 'smooth' });
//   }, []);

//   return (
//     <Box>
//       <Paper
//         elevation={isMobile ? 1 : 4}
//         sx={{
//           p: isMobile ? 2 : 4,
//           borderRadius: 2,
//           boxShadow: isMobile ? theme.shadows[1] : theme.shadows[4]
//         }}
//       >
//         {/* Header */}
//         <Box
//           sx={{
//             position: 'relative',
//             textAlign: 'center',
//             mb: isMobile ? 2 : 4,
//             px: isMobile ? 1 : 0
//           }}
//         >
//           {!isFollowUpRoute && (
//             <Button
//               onClick={() => navigate(-1)}
//               variant="outlined"
//               startIcon={<FiArrowLeft />}
//               sx={{
//                 position: 'absolute',
//                 left: 0,
//                 top: 0,
//                 borderColor:
//                   theme.palette.mode === 'light'
//                     ? 'rgba(0, 0, 0, 0.23)'
//                     : 'rgba(255, 255, 255, 0.23)',
//                 color: theme.palette.text.primary,
//                 textTransform: 'none',
//                 borderRadius: 2,
//                 px: 2,
//                 py: 1,
//                 '&:hover': {
//                   borderColor: theme.palette.primary.main,
//                   backgroundColor: theme.palette.action.hover
//                 },
//                 ...(isMobile && {
//                   fontSize: '0.75rem',
//                   px: 1.5,
//                   py: 0.5
//                 })
//               }}
//             >
//               {isMobile ? 'Back' : 'Back to Forms'}
//             </Button>
//           )}

//           <Box
//             sx={{
//               display: 'flex',
//               alignItems: 'center',
//               justifyContent: 'center',
//               mb: 1,
//               flexDirection: isMobile ? 'column' : 'row',
//               mt: isMobile && !isFollowUpRoute ? 4 : 0,
//               gap: isMobile ? 1 : 2
//             }}
//           >
//             <Box
//               sx={{
//                 backgroundColor: theme.palette.error.light,
//                 p: 1.5,
//                 borderRadius: '50%',
//                 display: 'flex',
//                 alignItems: 'center',
//                 justifyContent: 'center'
//               }}
//             >
//               <FaFileAlt
//                 size={isMobile ? 24 : 32}
//                 style={{
//                   color: theme.palette.error.contrastText
//                 }}
//               />
//             </Box>
//             <Typography
//               variant={isMobile ? 'h5' : 'h4'}
//               component="h1"
//               sx={{
//                 fontWeight: 600,
//                 lineHeight: 1.2,
//                 color: theme.palette.text.primary
//               }}
//             >
//               {isMainFormRoute ? 'Data Breach Incident Report' : 'Data Breach Follow-Up Form'}
//             </Typography>
//           </Box>

//           <Typography
//             variant={isMobile ? 'body2' : 'subtitle1'}
//             sx={{
//               color: 'text.secondary',
//               maxWidth: 600,
//               margin: '0 auto',
//               px: isMobile ? 1 : 2,
//               lineHeight: 1.4
//             }}
//           >
//             Ultra Care Services -{' '}
//             {isMainFormRoute
//               ? 'For documenting data breach incidents'
//               : 'For follow-up actions on data breach incidents'}
//           </Typography>
//         </Box>

//         {/* Success/Error Messages */}
//         {message && (
//           <Alert severity="success" sx={{ mb: 2 }} onClose={() => dispatch(clearDataBreachState())}>
//             {message}
//           </Alert>
//         )}
//         {error && (
//           <Alert severity="error" sx={{ mb: 2 }} onClose={() => dispatch(clearDataBreachState())}>
//             {error}
//           </Alert>
//         )}
//         {isFollowUpRoute && alreadyFilled && (
//           <Alert severity="warning" sx={{ mb: 2 }}>
//             This follow-up form has already been filled.
//           </Alert>
//         )}

//         {isMainFormRoute && (
//           <form onSubmit={mainForm.handleSubmit(onSubmitMain)}>
//             {/* General Information */}
//             <Box sx={{ mb: isMobile ? 3 : 4 }}>
//               <Box
//                 sx={{
//                   display: 'flex',
//                   alignItems: 'center',
//                   mb: isMobile ? 1 : 2,
//                   pl: 1
//                 }}
//               >
//                 <FaFileAlt
//                   size={isMobile ? 16 : 20}
//                   style={{
//                     marginRight: 8,
//                     color: theme.palette.primary.main
//                   }}
//                 />
//                 <Typography
//                   variant={isMobile ? 'h6' : 'h5'}
//                   component="h2"
//                   sx={{
//                     fontWeight: 500,
//                     fontSize: isMobile ? '1.1rem' : '1.5rem'
//                   }}
//                 >
//                   General Information
//                 </Typography>
//               </Box>
//               <Divider sx={{ mb: isMobile ? 2 : 3 }} />

//               <Grid container spacing={isMobile ? 1 : 2}>
//                 <Grid item xs={12} sm={6}>
//                   <Controller
//                     name="date_of_incident"
//                     control={mainForm.control}
//                     render={({ field }) => (
//                       <TextField
//                         size="small"
//                         label="Date of Incident"
//                         type="date"
//                         fullWidth
//                         margin="normal"
//                         InputLabelProps={{ shrink: true }}
//                         InputProps={{
//                           startAdornment: (
//                             <InputAdornment position="start">
//                               <FaCalendarAlt size={16} />
//                             </InputAdornment>
//                           )
//                         }}
//                         {...field}
//                         error={!!mainForm.formState.errors.date_of_incident}
//                         helperText={mainForm.formState.errors.date_of_incident?.message as string}
//                       />
//                     )}
//                   />
//                 </Grid>
//                 <Grid item xs={12} sm={6}>
//                   <Controller
//                     name="time_of_incident"
//                     control={mainForm.control}
//                     render={({ field }) => (
//                       <TextField
//                         size="small"
//                         label="Time of Incident"
//                         type="time"
//                         fullWidth
//                         margin="normal"
//                         InputLabelProps={{ shrink: true }}
//                         InputProps={{
//                           startAdornment: (
//                             <InputAdornment position="start">
//                               <FaClock size={16} />
//                             </InputAdornment>
//                           )
//                         }}
//                         {...field}
//                         error={!!mainForm.formState.errors.time_of_incident}
//                         helperText={mainForm.formState.errors.time_of_incident?.message as string}
//                       />
//                     )}
//                   />
//                 </Grid>
//                 <Grid item xs={12}>
//                   <Controller
//                     name="location_of_incident"
//                     control={mainForm.control}
//                     render={({ field }) => (
//                       <TextField
//                         size="small"
//                         label="Location of Incident"
//                         fullWidth
//                         margin="normal"
//                         placeholder="e.g., Office, Online System, External Location"
//                         InputProps={{
//                           startAdornment: (
//                             <InputAdornment position="start">
//                               <FaMapMarkerAlt size={16} />
//                             </InputAdornment>
//                           )
//                         }}
//                         {...field}
//                         error={!!mainForm.formState.errors.location_of_incident}
//                         helperText={
//                           mainForm.formState.errors.location_of_incident?.message as string
//                         }
//                       />
//                     )}
//                   />
//                 </Grid>
//                 <Grid item xs={12}>
//                   <FormControl component="fieldset" margin="normal" fullWidth>
//                     <Typography
//                       variant={isMobile ? 'subtitle2' : 'subtitle1'}
//                       sx={{ mb: 1, pl: 1, display: 'flex', alignItems: 'center' }}
//                     >
//                       <FaDatabase size={16} style={{ marginRight: 8 }} />
//                       Type of Data Involved
//                     </Typography>
//                     <Controller
//                       name="type_of_data"
//                       control={mainForm.control}
//                       render={({ field }) => (
//                         <RadioGroup
//                           {...field}
//                           onChange={(e) => field.onChange(e.target.value)}
//                           sx={{
//                             display: 'flex',
//                             flexDirection: isMobile ? 'column' : 'row',
//                             flexWrap: 'wrap',
//                             gap: isMobile ? 0.5 : 1,
//                             pl: 2
//                           }}
//                         >
//                           <FormControlLabel
//                             value="Personal"
//                             control={<Radio size="small" color="primary" />}
//                             label={
//                               <Typography variant={isMobile ? 'body2' : 'body1'}>
//                                 Personal
//                               </Typography>
//                             }
//                           />
//                           <FormControlLabel
//                             value="Financial"
//                             control={<Radio size="small" color="primary" />}
//                             label={
//                               <Typography variant={isMobile ? 'body2' : 'body1'}>
//                                 Financial
//                               </Typography>
//                             }
//                           />
//                           <FormControlLabel
//                             value="Medical"
//                             control={<Radio size="small" color="primary" />}
//                             label={
//                               <Typography variant={isMobile ? 'body2' : 'body1'}>
//                                 Medical
//                               </Typography>
//                             }
//                           />
//                           <FormControlLabel
//                             value="Other"
//                             control={<Radio size="small" color="primary" />}
//                             label={
//                               <Typography variant={isMobile ? 'body2' : 'body1'}>Other</Typography>
//                             }
//                           />
//                         </RadioGroup>
//                       )}
//                     />
//                     {mainForm.formState.errors.type_of_data && (
//                       <Typography color="error" variant="caption" sx={{ pl: 2 }}>
//                         {mainForm.formState.errors.type_of_data.message as string}
//                       </Typography>
//                     )}
//                   </FormControl>
//                   {type_of_data === 'Other' && (
//                     <Box sx={{ pl: isMobile ? 2 : 4, mt: 1 }}>
//                       <Controller
//                         name="other_type_of_data"
//                         control={mainForm.control}
//                         render={({ field }) => (
//                           <TextField
//                             size="small"
//                             label="Specify Other Data Type"
//                             fullWidth
//                             margin="normal"
//                             InputProps={{
//                               startAdornment: (
//                                 <InputAdornment position="start">
//                                   <FaDatabase size={16} />
//                                 </InputAdornment>
//                               )
//                             }}
//                             {...field}
//                             error={!!mainForm.formState.errors.other_type_of_data}
//                             helperText={
//                               mainForm.formState.errors.other_type_of_data?.message as string
//                             }
//                           />
//                         )}
//                       />
//                     </Box>
//                   )}
//                 </Grid>
//               </Grid>
//             </Box>

//             {/* Incident Details */}
//             <Box sx={{ mb: isMobile ? 3 : 4 }}>
//               <Box
//                 sx={{
//                   display: 'flex',
//                   alignItems: 'center',
//                   mb: isMobile ? 1 : 2,
//                   pl: 1
//                 }}
//               >
//                 <FaExclamationTriangle
//                   size={isMobile ? 16 : 20}
//                   style={{
//                     marginRight: 8,
//                     color: theme.palette.error.main
//                   }}
//                 />
//                 <Typography
//                   variant={isMobile ? 'h6' : 'h5'}
//                   component="h2"
//                   sx={{
//                     fontWeight: 500,
//                     fontSize: isMobile ? '1.1rem' : '1.5rem'
//                   }}
//                 >
//                   Incident Details
//                 </Typography>
//               </Box>
//               <Divider sx={{ mb: isMobile ? 2 : 3 }} />

//               <Grid container spacing={isMobile ? 1 : 2}>
//                 <Grid item xs={12}>
//                   <Controller
//                     name="description"
//                     control={mainForm.control}
//                     render={({ field }) => (
//                       <TextField
//                         size="small"
//                         label="Description of the Breach"
//                         multiline
//                         rows={isMobile ? 3 : 4}
//                         fullWidth
//                         margin="normal"
//                         placeholder="Provide a detailed account of the breach"
//                         {...field}
//                         error={!!mainForm.formState.errors.description}
//                         helperText={mainForm.formState.errors.description?.message as string}
//                       />
//                     )}
//                   />
//                 </Grid>
//                 <Grid item xs={12} sm={6}>
//                   <Controller
//                     name="individuals_affected"
//                     control={mainForm.control}
//                     render={({ field }) => (
//                       <TextField
//                         size="small"
//                         label="Individuals Affected"
//                         multiline
//                         rows={isMobile ? 2 : 2}
//                         fullWidth
//                         margin="normal"
//                         placeholder="e.g., Client: John Doe, Staff: Jane Smith"
//                         InputProps={{
//                           startAdornment: (
//                             <InputAdornment position="start">
//                               <FaUserCircle size={16} />
//                             </InputAdornment>
//                           )
//                         }}
//                         {...field}
//                         error={!!mainForm.formState.errors.individuals_affected}
//                         helperText={
//                           mainForm.formState.errors.individuals_affected?.message as string
//                         }
//                       />
//                     )}
//                   />
//                 </Grid>
//                 <Grid item xs={12} sm={6}>
//                   <Controller
//                     name="contact_info"
//                     control={mainForm.control}
//                     render={({ field }) => (
//                       <TextField
//                         size="small"
//                         label="Contact Information"
//                         multiline
//                         rows={isMobile ? 2 : 2}
//                         fullWidth
//                         margin="normal"
//                         placeholder="e.g., Phone, Email of affected individuals"
//                         InputProps={{
//                           startAdornment: (
//                             <InputAdornment position="start">
//                               <FaUserCircle size={16} />
//                             </InputAdornment>
//                           )
//                         }}
//                         {...field}
//                         error={!!mainForm.formState.errors.contact_info}
//                         helperText={mainForm.formState.errors.contact_info?.message as string}
//                       />
//                     )}
//                   />
//                 </Grid>
//                 <Grid item xs={12}>
//                   <Controller
//                     name="immediate_actions"
//                     control={mainForm.control}
//                     render={({ field }) => (
//                       <TextField
//                         size="small"
//                         label="Immediate Actions Taken"
//                         multiline
//                         rows={isMobile ? 3 : 4}
//                         fullWidth
//                         margin="normal"
//                         placeholder="e.g., Secured data, notified management"
//                         {...field}
//                         error={!!mainForm.formState.errors.immediate_actions}
//                         helperText={mainForm.formState.errors.immediate_actions?.message as string}
//                       />
//                     )}
//                   />
//                 </Grid>
//                 <Grid item xs={12}>
//                   <Controller
//                     name="photo"
//                     control={mainForm.control}
//                     render={({ field: { onChange, onBlur, ...field } }) => (
//                       <Box>
//                         <TextField
//                           size="small"
//                           label="Upload Photo"
//                           type="file"
//                           fullWidth
//                           margin="normal"
//                           inputRef={fileInputRef}
//                           InputLabelProps={{ shrink: true }}
//                           InputProps={{
//                             startAdornment: (
//                               <InputAdornment position="start">
//                                 <FaCamera size={16} />
//                               </InputAdornment>
//                             ),
//                             inputProps: {
//                               accept: 'image/*'
//                             }
//                           }}
//                           onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
//                             handlePhotoChange(e, onChange)
//                           }
//                           onBlur={onBlur}
//                           error={!!mainForm.formState.errors.photo}
//                           helperText={mainForm.formState.errors.photo?.message as string}
//                         />
//                         {photoPreview && isLargeScreen && (
//                           <Box sx={{ mt: 1, textAlign: 'left' }}>
//                             <Typography variant="subtitle2" sx={{ mb: 1 }}>
//                               Photo Preview
//                             </Typography>
//                             <Box sx={{ position: 'relative', display: 'inline-block' }}>
//                               <Avatar
//                                 src={photoPreview}
//                                 variant="rounded"
//                                 sx={{
//                                   width: isMobile ? '100%' : 150,
//                                   height: 150,
//                                   objectFit: 'contain'
//                                 }}
//                               />
//                               <IconButton
//                                 size="small"
//                                 onClick={handleRemovePhoto}
//                                 sx={{
//                                   position: 'absolute',
//                                   top: -10,
//                                   right: -10,
//                                   bgcolor: theme.palette.error.main,
//                                   color: theme.palette.common.white,
//                                   '&:hover': {
//                                     bgcolor: theme.palette.error.dark
//                                   }
//                                 }}
//                               >
//                                 <FiTrash size={16} />
//                               </IconButton>
//                             </Box>
//                           </Box>
//                         )}
//                       </Box>
//                     )}
//                   />
//                 </Grid>
//                 {photoPreview && !isLargeScreen && (
//                   <Grid item xs={12}>
//                     <Box
//                       sx={{ display: 'flex', justifyContent: isMobile ? 'center' : 'flex-start' }}
//                     >
//                       <Box sx={{ position: 'relative' }}>
//                         <Avatar
//                           src={photoPreview}
//                           variant="rounded"
//                           sx={{
//                             width: isMobile ? '100%' : 150,
//                             height: isMobile ? 150 : 150,
//                             mt: isMobile ? 1 : 0,
//                             objectFit: 'contain'
//                           }}
//                         />
//                         <IconButton
//                           size="small"
//                           onClick={handleRemovePhoto}
//                           sx={{
//                             position: 'absolute',
//                             top: -10,
//                             right: -10,
//                             bgcolor: theme.palette.error.main,
//                             color: theme.palette.common.white,
//                             '&:hover': {
//                               bgcolor: theme.palette.error.dark
//                             }
//                           }}
//                         >
//                           <FiTrash size={16} />
//                         </IconButton>
//                       </Box>
//                     </Box>
//                   </Grid>
//                 )}
//               </Grid>
//             </Box>

//             {/* Reporter Details */}
//             <Box sx={{ mb: isMobile ? 3 : 4 }}>
//               <Box
//                 sx={{
//                   display: 'flex',
//                   alignItems: 'center',
//                   mb: isMobile ? 1 : 2,
//                   pl: 1
//                 }}
//               >
//                 <FaUserCircle
//                   size={isMobile ? 16 : 20}
//                   style={{
//                     marginRight: 8,
//                     color: theme.palette.primary.main
//                   }}
//                 />
//                 <Typography
//                   variant={isMobile ? 'h6' : 'h5'}
//                   component="h2"
//                   sx={{
//                     fontWeight: 500,
//                     fontSize: isMobile ? '1.1rem' : '1.5rem'
//                   }}
//                 >
//                   Reporter Details
//                 </Typography>
//               </Box>
//               <Divider sx={{ mb: isMobile ? 2 : 3 }} />

//               <Grid container spacing={isMobile ? 1 : 2}>
//                 <Grid item xs={12} sm={6}>
//                   <Controller
//                     name="reporter_name"
//                     control={mainForm.control}
//                     render={({ field }) => (
//                       <TextField
//                         size="small"
//                         label="Reporter's Full Name"
//                         fullWidth
//                         margin="normal"
//                         InputProps={{
//                           startAdornment: (
//                             <InputAdornment position="start">
//                               <FaUserCircle size={16} />
//                             </InputAdornment>
//                           )
//                         }}
//                         {...field}
//                         error={!!mainForm.formState.errors.reporter_name}
//                         helperText={mainForm.formState.errors.reporter_name?.message as string}
//                       />
//                     )}
//                   />
//                 </Grid>
//                 <Grid item xs={12}>
//                   <FormControl component="fieldset" margin="normal" fullWidth>
//                     <Typography
//                       variant={isMobile ? 'subtitle2' : 'subtitle1'}
//                       sx={{ mb: 1, pl: 1 }}
//                     >
//                       Is the Incident Resolved?
//                     </Typography>
//                     <Controller
//                       name="resolved"
//                       control={followUpForm.control}
//                       render={({ field }) => (
//                         <RadioGroup
//                           {...field}
//                           onChange={(e) => field.onChange(e.target.value)}
//                           sx={{
//                             display: 'flex',
//                             flexDirection: isMobile ? 'column' : 'row',
//                             gap: isMobile ? 0.5 : 1,
//                             pl: 2
//                           }}
//                         >
//                           <FormControlLabel
//                             value="Yes"
//                             control={<Radio size="small" color="primary" />}
//                             label={
//                               <Typography variant={isMobile ? 'body2' : 'body1'}>Yes</Typography>
//                             }
//                           />
//                           <FormControlLabel
//                             value="No"
//                             control={<Radio size="small" color="primary" />}
//                             label={
//                               <Typography variant={isMobile ? 'body2' : 'body1'}>No</Typography>
//                             }
//                           />
//                         </RadioGroup>
//                       )}
//                     />
//                     {followUpForm.formState.errors.resolved && (
//                       <Typography color="error" variant="caption" sx={{ pl: 2 }}>
//                         {followUpForm.formState.errors.resolved.message as string}
//                       </Typography>
//                     )}
//                   </FormControl>
//                 </Grid>
//                 <Grid item xs={12} sm={6}>
//                   <Controller
//                     name="signature"
//                     control={mainForm.control}
//                     render={({ field }) => (
//                       <TextField
//                         size="small"
//                         label="Signature"
//                         fullWidth
//                         margin="normal"
//                         InputProps={{
//                           startAdornment: (
//                             <InputAdornment position="start">
//                               <FaSignature size={16} />
//                             </InputAdornment>
//                           )
//                         }}
//                         {...field}
//                         error={!!mainForm.formState.errors.signature}
//                         helperText={mainForm.formState.errors.signature?.message as string}
//                       />
//                     )}
//                   />
//                 </Grid>
//                 <Grid item xs={12}>
//                   <Controller
//                     name="date_completed"
//                     control={mainForm.control}
//                     render={({ field }) => (
//                       <TextField
//                         size="small"
//                         label="Date Completed"
//                         type="date"
//                         fullWidth
//                         margin="normal"
//                         InputLabelProps={{ shrink: true }}
//                         InputProps={{
//                           startAdornment: (
//                             <InputAdornment position="start">
//                               <FaCalendarAlt size={16} />
//                             </InputAdornment>
//                           )
//                         }}
//                         {...field}
//                         error={!!mainForm.formState.errors.date_completed}
//                         helperText={mainForm.formState.errors.date_completed?.message as string}
//                       />
//                     )}
//                   />
//                 </Grid>
//               </Grid>
//             </Box>

//             {/* Submit and Reset Buttons */}
//             <Box
//               sx={{
//                 display: 'flex',
//                 justifyContent: 'center',
//                 gap: isMobile ? 2 : 3,
//                 mt: isMobile ? 3 : 4,
//                 mb: isMobile ? 1 : 0,
//                 flexDirection: isMobile ? 'column' : 'row'
//               }}
//             >
//               <Button
//                 type="button"
//                 variant="outlined"
//                 color="secondary"
//                 size={isMobile ? 'medium' : 'large'}
//                 sx={{
//                   px: isMobile ? 4 : 6,
//                   py: isMobile ? 1 : 1.5,
//                   fontSize: isMobile ? '0.9rem' : '1.1rem',
//                   fontWeight: 600,
//                   borderRadius: 2,
//                   boxShadow: 1,
//                   '&:hover': {
//                     boxShadow: 3,
//                     transform: 'translateY(-1px)'
//                   },
//                   transition: 'all 0.2s ease',
//                   width: isMobile ? '100%' : 'auto'
//                 }}
//                 startIcon={<FaUndo size={isMobile ? 14 : 18} />}
//                 onClick={handleResetMain}
//                 disabled={!mainForm.formState.isDirty || loading}
//               >
//                 Reset Form
//               </Button>
//               <Button
//                 type="submit"
//                 variant="contained"
//                 color="primary"
//                 size={isMobile ? 'medium' : 'large'}
//                 sx={{
//                   px: isMobile ? 4 : 6,
//                   py: isMobile ? 1 : 1.5,
//                   fontSize: isMobile ? '0.9rem' : '1.1rem',
//                   fontWeight: 600,
//                   borderRadius: 2,
//                   boxShadow: 1,
//                   '&:hover': {
//                     boxShadow: 3,
//                     transform: 'translateY(-1px)'
//                   },
//                   transition: 'all 0.2s ease',
//                   width: isMobile ? '100%' : 'auto'
//                 }}
//                 startIcon={<FaFileAlt size={isMobile ? 14 : 18} />}
//                 disabled={loading}
//               >
//                 {loading ? <CircularProgress size={24} /> : 'Submit'}
//               </Button>
//             </Box>
//           </form>
//         )}

//         {isFollowUpRoute && (
//           <form onSubmit={followUpForm.handleSubmit(onSubmitFollowUp)}>
//             {/* Follow-Up Actions */}
//             <Box sx={{ mb: isMobile ? 3 : 4 }}>
//               <Box
//                 sx={{
//                   display: 'flex',
//                   alignItems: 'center',
//                   mb: isMobile ? 1 : 2,
//                   pl: 1
//                 }}
//               >
//                 <FaShieldAlt
//                   size={isMobile ? 16 : 20}
//                   style={{
//                     marginRight: 8,
//                     color: theme.palette.primary.main
//                   }}
//                 />
//                 <Typography
//                   variant={isMobile ? 'h6' : 'h5'}
//                   component="h2"
//                   sx={{
//                     fontWeight: 500,
//                     fontSize: isMobile ? '1.1rem' : '1.5rem'
//                   }}
//                 >
//                   Follow-Up Actions
//                 </Typography>
//               </Box>
//               <Divider sx={{ mb: isMobile ? 2 : 3 }} />

//               <Grid container spacing={isMobile ? 1 : 2}>
//                 <Grid item xs={12}>
//                   <FormControl component="fieldset" margin="normal" fullWidth>
//                     <Typography
//                       variant={isMobile ? 'subtitle2' : 'subtitle1'}
//                       sx={{ mb: 1, pl: 1 }}
//                     >
//                       Was the Breach Reported Externally?
//                     </Typography>
//                     <Controller
//                       name="breach_reported_externally"
//                       control={followUpForm.control}
//                       render={({ field }) => (
//                         <RadioGroup
//                           {...field}
//                           onChange={(e) => field.onChange(e.target.value)}
//                           sx={{
//                             display: 'flex',
//                             flexDirection: isMobile ? 'column' : 'row',
//                             flexWrap: 'wrap',
//                             gap: isMobile ? 0.5 : 1,
//                             pl: 2
//                           }}
//                         >
//                           <FormControlLabel
//                             value="Yes"
//                             control={<Radio size="small" color="primary" />}
//                             label={
//                               <Typography variant={isMobile ? 'body2' : 'body1'}>Yes</Typography>
//                             }
//                           />
//                           <FormControlLabel
//                             value="No"
//                             control={<Radio size="small" color="primary" />}
//                             label={
//                               <Typography variant={isMobile ? 'body2' : 'body1'}>No</Typography>
//                             }
//                           />
//                         </RadioGroup>
//                       )}
//                     />
//                     {followUpForm.formState.errors.breach_reported_externally && (
//                       <Typography color="error" variant="caption" sx={{ pl: 2 }}>
//                         {followUpForm.formState.errors.breach_reported_externally.message as string}
//                       </Typography>
//                     )}
//                   </FormControl>
//                   {breach_reported_externally === 'Yes' && (
//                     <Box sx={{ pl: isMobile ? 2 : 4, mt: 1 }}>
//                       <Controller
//                         name="reported_to"
//                         control={followUpForm.control}
//                         render={({ field }) => (
//                           <TextField
//                             size="small"
//                             label="To Whom Was It Reported"
//                             fullWidth
//                             margin="normal"
//                             placeholder="e.g., NDIS Commission, Police"
//                             InputProps={{
//                               startAdornment: (
//                                 <InputAdornment position="start">
//                                   <FaUserCircle size={16} />
//                                 </InputAdornment>
//                               )
//                             }}
//                             {...field}
//                             error={!!followUpForm.formState.errors.reported_to}
//                             helperText={
//                               followUpForm.formState.errors.reported_to?.message as string
//                             }
//                           />
//                         )}
//                       />
//                     </Box>
//                   )}
//                 </Grid>
//                 <Grid item xs={12}>
//                   <Controller
//                     name="prevention_recommendations"
//                     control={followUpForm.control}
//                     render={({ field }) => (
//                       <TextField
//                         size="small"
//                         label="Recommendations for Prevention"
//                         multiline
//                         rows={isMobile ? 3 : 4}
//                         fullWidth
//                         margin="normal"
//                         placeholder="Suggestions to prevent future breaches"
//                         {...field}
//                         error={!!followUpForm.formState.errors.prevention_recommendations}
//                         helperText={
//                           followUpForm.formState.errors.prevention_recommendations
//                             ?.message as string
//                         }
//                       />
//                     )}
//                   />
//                 </Grid>
//               </Grid>
//             </Box>

//             {/* Submit and Reset Buttons */}
//             <Box
//               sx={{
//                 display: 'flex',
//                 justifyContent: 'center',
//                 gap: isMobile ? 2 : 3,
//                 mt: isMobile ? 3 : 4,
//                 mb: isMobile ? 1 : 0,
//                 flexDirection: isMobile ? 'column' : 'row'
//               }}
//             >
//               <Button
//                 type="button"
//                 variant="outlined"
//                 color="secondary"
//                 size={isMobile ? 'medium' : 'large'}
//                 sx={{
//                   px: isMobile ? 4 : 6,
//                   py: isMobile ? 1 : 1.5,
//                   fontSize: isMobile ? '0.9rem' : '1.1rem',
//                   fontWeight: 600,
//                   borderRadius: 2,
//                   boxShadow: 1,
//                   '&:hover': {
//                     boxShadow: 3,
//                     transform: 'translateY(-1px)'
//                   },
//                   transition: 'all 0.2s ease',
//                   width: isMobile ? '100%' : 'auto'
//                 }}
//                 startIcon={<FaUndo size={isMobile ? 14 : 18} />}
//                 onClick={handleResetFollowUp}
//                 disabled={!followUpForm.formState.isDirty || loading}
//               >
//                 Reset Form
//               </Button>
//               <Button
//                 type="submit"
//                 variant="contained"
//                 color="primary"
//                 size={isMobile ? 'medium' : 'large'}
//                 sx={{
//                   px: isMobile ? 4 : 6,
//                   py: isMobile ? 1 : 1.5,
//                   fontSize: isMobile ? '0.9rem' : '1.1rem',
//                   fontWeight: 600,
//                   borderRadius: 2,
//                   boxShadow: 1,
//                   '&:hover': {
//                     boxShadow: 3,
//                     transform: 'translateY(-1px)'
//                   },
//                   transition: 'all 0.2s ease',
//                   width: isMobile ? '100%' : 'auto'
//                 }}
//                 startIcon={<FaFileAlt size={isMobile ? 14 : 18} />}
//                 disabled={loading || !incidentId}
//               >
//                 {loading ? <CircularProgress size={24} /> : 'Submit Follow-Up'}
//               </Button>
//             </Box>
//           </form>
//         )}
//       </Paper>
//     </Box>
//   );
// };

// export default DataBreachIncidentForm;


import { yupResolver } from '@hookform/resolvers/yup';
import {
  Alert,
  Avatar,
  Box,
  Button,
  CircularProgress,
  Divider,
  FormControl,
  FormControlLabel,
  Grid,
  IconButton,
  InputAdornment,
  Paper,
  Radio,
  RadioGroup,
  TextField,
  Typography,
  useMediaQuery,
  useTheme
} from '@mui/material';
import { AppDispatch, RootState } from 'app/store';
import React, { useEffect, useRef, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import {
  FaCalendarAlt,
  FaCamera,
  FaClock,
  FaDatabase,
  FaExclamationTriangle,
  FaFileAlt,
  FaMapMarkerAlt,
  FaShieldAlt,
  FaSignature,
  FaUndo,
  FaUserCircle
} from 'react-icons/fa';
import { FiArrowLeft, FiTrash } from 'react-icons/fi';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { DataBreach } from 'slices/NdisSlices/carporateServices/IncidentsListSlice';
import {
  clearDataBreachState,
  DataBreachFormData,
  submitDataBreach
} from 'slices/NdisSlices/reportAllForms/dataBreachSlice';
import * as yup from 'yup';

// Validation schemas
const mainSchema = yup
  .object({
    id: yup.string().optional(),
    date_of_incident: yup.string().required('Date of incident is required'),
    time_of_incident: yup.string().required('Time of incident is required'),
    location_of_incident: yup.string().required('Location is required'),
    type_of_data: yup.string().required('Data type is required'),
    other_type_of_data: yup.string().when('type_of_data', {
      is: 'Other',
      then: (schema) => schema.required('Please specify other data type'),
      otherwise: (schema) => schema.optional().default('')
    }),
    description: yup.string().required('Description is required'),
    individuals_affected: yup.string().required('Individuals affected is required'),
    contact_info: yup.string().required('Contact information is required'),
    immediate_actions: yup.string().required('Immediate actions taken is required'),
    breach_reported_externally: yup.string().optional().default(''),
    reported_to: yup.string().optional().default(''),
    prevention_recommendations: yup.string().optional().default(''),
    reporter_name: yup.string().required('Reporter name is required'),
    signature: yup.string().required('Signature is required'),
    date_completed: yup.string().required('Date completed is required'),
    photo: yup.mixed<File>().optional().default(undefined),
    client_email: yup.string().optional().default('')
  })
  .required();

const followUpSchema = yup
  .object({
    id: yup.string().optional(),
    date_of_incident: yup.string().optional().default(''),
    time_of_incident: yup.string().optional().default(''),
    location_of_incident: yup.string().optional().default(''),
    type_of_data: yup.string().optional().default(''),
    other_type_of_data: yup.string().optional().default(''),
    description: yup.string().optional().default(''),
    individuals_affected: yup.string().optional().default(''),
    contact_info: yup.string().optional().default(''),
    immediate_actions: yup.string().optional().default(''),
    breach_reported_externally: yup.string().required('Please specify if reported externally'),
    reported_to: yup.string().when('breach_reported_externally', {
      is: 'Yes',
      then: (schema) => schema.required('Please specify to whom it was reported'),
      otherwise: (schema) => schema.optional().default('')
    }),
    resolved: yup
      .string()
      .oneOf(['Yes', 'No'], 'Please specify if the incident is resolved')
      .required('Please specify if the incident is resolved'),
    prevention_recommendations: yup
      .string()
      .required('Recommendations for prevention are required'),
    reporter_name: yup.string().optional().default(''),
    signature: yup.string().optional().default(''),
    date_completed: yup.string().optional().default(''),
    photo: yup.mixed<File>().optional().default(undefined),
    client_email: yup.string().optional().default('')
  })
  .required();

interface Props {
  initialData?: DataBreach;
  onClose?: () => void;
}

const DataBreachIncidentForm: React.FC<Props> = ({ initialData, onClose }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isLargeScreen = useMediaQuery(theme.breakpoints.up('lg'));
  const dispatch = useDispatch<AppDispatch>();
  const useTypedSelector: TypedUseSelectorHook<RootState> = useSelector;
  const { message, loading, error } = useTypedSelector((state) => state.dataBreach);
  const [photoPreview, setPhotoPreview] = useState<string | null>(null);
  const fileInputRef = useRef<HTMLInputElement>(null);
  const navigate = useNavigate();
  const location = useLocation();

  // Local storage data
  const selectedClient = JSON.parse(localStorage.getItem('selectedClient') || '{}') as {
    email?: string;
  };

  // Determine which form section to show
  const searchParams = new URLSearchParams(location.search);
  const tabParam = searchParams.get('tab') || 'incidents';
  const incidentId = initialData?.id || undefined;

  const isMainFormRoute = location.pathname === '/dataBreach-Incident';
  const isFollowUpRoute =
    location.pathname === '/ndis-operations/corporate-services' && tabParam === 'incidents';

  // Check if Follow-Up form is already filled
  const [alreadyFilled, setAlreadyFilled] = useState(false);
  useEffect(() => {
    if (isFollowUpRoute && initialData) {
      const isFilled = [
        initialData.breach_reported_externally,
        initialData.reported_to,
        initialData.prevention,
        initialData.resolved
      ].some((field) => field !== undefined && field !== null && field !== '');
      setAlreadyFilled(isFilled);
    } else {
      setAlreadyFilled(false);
    }
  }, [initialData, isFollowUpRoute]);

  // Use separate useForm hooks for each route
  const defaultDateTime = new Date().toISOString().split('T')[0];
  const mainForm = useForm<DataBreachFormData>({
    resolver: yupResolver(mainSchema) as any,
    defaultValues: {
      id: initialData?.id || '',
      date_of_incident: initialData?.date || defaultDateTime,
      time_of_incident: initialData?.time || '',
      location_of_incident: initialData?.location || '',
      type_of_data: initialData?.type_of_data || '',
      other_type_of_data: initialData?.type_of_data === 'Other' ? initialData?.type_of_data : '',
      description: initialData?.description || '',
      individuals_affected: initialData?.individuals_affected || '',
      contact_info: initialData?.contact_info || '',
      immediate_actions: initialData?.immediate_actions || '',
      breach_reported_externally: initialData?.breach_reported_externally || '',
      reported_to: initialData?.reported_to || '',
      prevention_recommendations: initialData?.prevention || '',
      reporter_name: initialData?.reporter_name || '',
      signature: initialData?.signature || '',
      date_completed: initialData?.date_completed || defaultDateTime,
      photo: undefined,
      client_email: selectedClient?.email || ''
    }
  });

  const followUpForm = useForm<DataBreachFormData>({
    resolver: yupResolver(followUpSchema) as any,
    defaultValues: {
      id: initialData?.id || '',
      date_of_incident: initialData?.date || '',
      time_of_incident: initialData?.time || '',
      location_of_incident: initialData?.location || '',
      type_of_data: initialData?.type_of_data || '',
      other_type_of_data: initialData?.type_of_data === 'Other' ? initialData?.type_of_data : '',
      description: initialData?.description || '',
      individuals_affected: initialData?.individuals_affected || '',
      contact_info: initialData?.contact_info || '',
      immediate_actions: initialData?.immediate_actions || '',
      breach_reported_externally: initialData?.breach_reported_externally || '',
      reported_to: initialData?.reported_to || '',
      prevention_recommendations: initialData?.prevention || '',
      reporter_name: initialData?.reporter_name || '',
      signature: initialData?.signature || '',
      date_completed: initialData?.date_completed || defaultDateTime,
      photo: undefined,
      client_email: selectedClient?.email || '',
      resolved: initialData?.resolved || ''
    }
  });

  const type_of_data = isMainFormRoute
    ? mainForm.watch('type_of_data')
    : followUpForm.watch('type_of_data');
  const breach_reported_externally = isMainFormRoute
    ? mainForm.watch('breach_reported_externally')
    : followUpForm.watch('breach_reported_externally');

  const handlePhotoChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    onChange: (value: File | undefined) => void
  ) => {
    const file = e.target.files?.[0];
    if (file) {
      onChange(file);
      const reader = new FileReader();
      reader.onloadend = () => {
        setPhotoPreview(reader.result as string);
      };
      reader.readAsDataURL(file);
    } else {
      setPhotoPreview(null);
      onChange(undefined);
    }
  };

  const handleRemovePhoto = () => {
    setPhotoPreview(null);
    if (isMainFormRoute) {
      mainForm.setValue('photo', undefined, { shouldValidate: true });
    } else {
      followUpForm.setValue('photo', undefined, { shouldValidate: true });
    }
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  };

  const onSubmitMain = (data: DataBreachFormData) => {
    const payload: DataBreachFormData = {
      ...data,
      client_email: selectedClient.email || data.client_email
    };

    dispatch(submitDataBreach(payload)).then(() => {
      mainForm.reset();
      setPhotoPreview(null);
      if (fileInputRef.current) {
        fileInputRef.current.value = '';
      }
      setTimeout(() => dispatch(clearDataBreachState()), 5000);
    });
  };

  const onSubmitFollowUp = (data: DataBreachFormData) => {
    const payload: DataBreachFormData = {
      id: incidentId || initialData?.id,
      date_of_incident: initialData?.date || data.date_of_incident,
      time_of_incident: initialData?.time || data.time_of_incident,
      location_of_incident: initialData?.location || data.location_of_incident,
      type_of_data: initialData?.type_of_data || data.type_of_data,
      other_type_of_data:
        initialData?.type_of_data === 'Other'
          ? initialData?.type_of_data
          : data.type_of_data === 'Other'
          ? data.other_type_of_data
          : '',
      description: initialData?.description || data.description,
      individuals_affected: initialData?.individuals_affected || data.individuals_affected,
      contact_info: initialData?.contact_info || data.contact_info,
      immediate_actions: initialData?.immediate_actions || data.immediate_actions,
      breach_reported_externally: data.breach_reported_externally,
      reported_to: data.reported_to,
      prevention_recommendations: data.prevention_recommendations,
      reporter_name: initialData?.reporter_name || data.reporter_name,
      signature: initialData?.signature || data.signature,
      date_completed: initialData?.date_completed || data.date_completed,
      photo: initialData?.photo || '',
      client_email: selectedClient.email || data.client_email,
      resolved: data.resolved
    };

    dispatch(submitDataBreach(payload)).then(() => {
      followUpForm.reset();
      setPhotoPreview(null);
      if (fileInputRef.current) {
        fileInputRef.current.value = '';
      }
      setTimeout(() => dispatch(clearDataBreachState()), 5000);
      if (onClose) {
        onClose();
      }
    });
  };

  const handleResetMain = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    mainForm.reset();
    setPhotoPreview(null);
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
    dispatch(clearDataBreachState());
  };

  const handleResetFollowUp = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    followUpForm.reset();
    setPhotoPreview(null);
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
    dispatch(clearDataBreachState());
  };

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  return (
    <Box>
      <Paper
        elevation={isMobile ? 1 : 4}
        sx={{
          p: isMobile ? 2 : 4,
          borderRadius: 2,
          boxShadow: isMobile ? theme.shadows[1] : theme.shadows[4]
        }}
      >
        {/* Header */}
        <Box
          sx={{
            position: 'relative',
            textAlign: 'center',
            mb: isMobile ? 2 : 4,
            px: isMobile ? 1 : 0
          }}
        >
          {!isFollowUpRoute && (
            <Button
              onClick={() => navigate(-1)}
              variant="outlined"
              startIcon={<FiArrowLeft />}
              sx={{
                position: 'absolute',
                left: 0,
                top: 0,
                borderColor:
                  theme.palette.mode === 'light'
                    ? 'rgba(0, 0, 0, 0.23)'
                    : 'rgba(255, 255, 255, 0.23)',
                color: theme.palette.text.primary,
                textTransform: 'none',
                borderRadius: 2,
                px: 2,
                py: 1,
                '&:hover': {
                  borderColor: theme.palette.primary.main,
                  backgroundColor: theme.palette.action.hover
                },
                ...(isMobile && {
                  fontSize: '0.75rem',
                  px: 1.5,
                  py: 0.5
                })
              }}
            >
              {isMobile ? 'Back' : 'Back to Forms'}
            </Button>
          )}

          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              mb: 1,
              flexDirection: isMobile ? 'column' : 'row',
              mt: isMobile && !isFollowUpRoute ? 4 : 0,
              gap: isMobile ? 1 : 2
            }}
          >
            <Box
              sx={{
                backgroundColor: theme.palette.error.light,
                p: 1.5,
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              <FaFileAlt
                size={isMobile ? 24 : 32}
                style={{
                  color: theme.palette.error.contrastText
                }}
              />
            </Box>
            <Typography
              variant={isMobile ? 'h5' : 'h4'}
              component="h1"
              sx={{
                fontWeight: 600,
                lineHeight: 1.2,
                color: theme.palette.text.primary
              }}
            >
              {isMainFormRoute ? 'Data Breach Incident Report' : 'Data Breach Follow-Up Form'}
            </Typography>
          </Box>

          <Typography
            variant={isMobile ? 'body2' : 'subtitle1'}
            sx={{
              color: 'text.secondary',
              maxWidth: 600,
              margin: '0 auto',
              px: isMobile ? 1 : 2,
              lineHeight: 1.4
            }}
          >
            Ultra Care Services -{' '}
            {isMainFormRoute
              ? 'For documenting data breach incidents'
              : 'For follow-up actions on data breach incidents'}
          </Typography>
        </Box>

        {/* Success/Error Messages */}
        {message && (
          <Alert severity="success" sx={{ mb: 2 }} onClose={() => dispatch(clearDataBreachState())}>
            {message}
          </Alert>
        )}
        {error && (
          <Alert severity="error" sx={{ mb: 2 }} onClose={() => dispatch(clearDataBreachState())}>
            {error}
          </Alert>
        )}
        {isFollowUpRoute && alreadyFilled && (
          <Alert severity="warning" sx={{ mb: 2 }}>
            This follow-up form has already been filled.
          </Alert>
        )}

        {isMainFormRoute && (
          <form onSubmit={mainForm.handleSubmit(onSubmitMain)}>
            {/* General Information */}
            <Box sx={{ mb: isMobile ? 3 : 4 }}>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  mb: isMobile ? 1 : 2,
                  pl: 1
                }}
              >
                <FaFileAlt
                  size={isMobile ? 16 : 20}
                  style={{
                    marginRight: 8,
                    color: theme.palette.primary.main
                  }}
                />
                <Typography
                  variant={isMobile ? 'h6' : 'h5'}
                  component="h2"
                  sx={{
                    fontWeight: 500,
                    fontSize: isMobile ? '1.1rem' : '1.5rem'
                  }}
                >
                  General Information
                </Typography>
              </Box>
              <Divider sx={{ mb: isMobile ? 2 : 3 }} />

              <Grid container spacing={isMobile ? 1 : 2}>
                <Grid item xs={12} sm={6}>
                  <Controller
                    name="date_of_incident"
                    control={mainForm.control}
                    render={({ field }) => (
                      <TextField
                        size="small"
                        label="Date of Incident"
                        type="date"
                        fullWidth
                        margin="normal"
                        InputLabelProps={{ shrink: true }}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <FaCalendarAlt size={16} />
                            </InputAdornment>
                          )
                        }}
                        {...field}
                        error={!!mainForm.formState.errors.date_of_incident}
                        helperText={mainForm.formState.errors.date_of_incident?.message as string}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Controller
                    name="time_of_incident"
                    control={mainForm.control}
                    render={({ field }) => (
                      <TextField
                        size="small"
                        label="Time of Incident"
                        type="time"
                        fullWidth
                        margin="normal"
                        InputLabelProps={{ shrink: true }}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <FaClock size={16} />
                            </InputAdornment>
                          )
                        }}
                        {...field}
                        error={!!mainForm.formState.errors.time_of_incident}
                        helperText={mainForm.formState.errors.time_of_incident?.message as string}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Controller
                    name="location_of_incident"
                    control={mainForm.control}
                    render={({ field }) => (
                      <TextField
                        size="small"
                        label="Location of Incident"
                        fullWidth
                        margin="normal"
                        placeholder="e.g., Office, Online System, External Location"
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <FaMapMarkerAlt size={16} />
                            </InputAdornment>
                          )
                        }}
                        {...field}
                        error={!!mainForm.formState.errors.location_of_incident}
                        helperText={
                          mainForm.formState.errors.location_of_incident?.message as string
                        }
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12}>
                  <FormControl component="fieldset" margin="normal" fullWidth>
                    <Typography
                      variant={isMobile ? 'subtitle2' : 'subtitle1'}
                      sx={{ mb: 1, pl: 1, display: 'flex', alignItems: 'center' }}
                    >
                      <FaDatabase size={16} style={{ marginRight: 8 }} />
                      Type of Data Involved
                    </Typography>
                    <Controller
                      name="type_of_data"
                      control={mainForm.control}
                      render={({ field }) => (
                        <RadioGroup
                          {...field}
                          onChange={(e) => field.onChange(e.target.value)}
                          sx={{
                            display: 'flex',
                            flexDirection: isMobile ? 'column' : 'row',
                            flexWrap: 'wrap',
                            gap: isMobile ? 0.5 : 1,
                            pl: 2
                          }}
                        >
                          <FormControlLabel
                            value="Personal"
                            control={<Radio size="small" color="primary" />}
                            label={
                              <Typography variant={isMobile ? 'body2' : 'body1'}>
                                Personal
                              </Typography>
                            }
                          />
                          <FormControlLabel
                            value="Financial"
                            control={<Radio size="small" color="primary" />}
                            label={
                              <Typography variant={isMobile ? 'body2' : 'body1'}>
                                Financial
                              </Typography>
                            }
                          />
                          <FormControlLabel
                            value="Medical"
                            control={<Radio size="small" color="primary" />}
                            label={
                              <Typography variant={isMobile ? 'body2' : 'body1'}>
                                Medical
                              </Typography>
                            }
                          />
                          <FormControlLabel
                            value="Other"
                            control={<Radio size="small" color="primary" />}
                            label={
                              <Typography variant={isMobile ? 'body2' : 'body1'}>Other</Typography>
                            }
                          />
                        </RadioGroup>
                      )}
                    />
                    {mainForm.formState.errors.type_of_data && (
                      <Typography color="error" variant="caption" sx={{ pl: 2 }}>
                        {mainForm.formState.errors.type_of_data.message as string}
                      </Typography>
                    )}
                  </FormControl>
                  {type_of_data === 'Other' && (
                    <Box sx={{ pl: isMobile ? 2 : 4, mt: 1 }}>
                      <Controller
                        name="other_type_of_data"
                        control={mainForm.control}
                        render={({ field }) => (
                          <TextField
                            size="small"
                            label="Specify Other Data Type"
                            fullWidth
                            margin="normal"
                            InputProps={{
                              startAdornment: (
                                <InputAdornment position="start">
                                  <FaDatabase size={16} />
                                </InputAdornment>
                              )
                            }}
                            {...field}
                            error={!!mainForm.formState.errors.other_type_of_data}
                            helperText={
                              mainForm.formState.errors.other_type_of_data?.message as string
                            }
                          />
                        )}
                      />
                    </Box>
                  )}
                </Grid>
              </Grid>
            </Box>

            {/* Incident Details */}
            <Box sx={{ mb: isMobile ? 3 : 4 }}>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  mb: isMobile ? 1 : 2,
                  pl: 1
                }}
              >
                <FaExclamationTriangle
                  size={isMobile ? 16 : 20}
                  style={{
                    marginRight: 8,
                    color: theme.palette.error.main
                  }}
                />
                <Typography
                  variant={isMobile ? 'h6' : 'h5'}
                  component="h2"
                  sx={{
                    fontWeight: 500,
                    fontSize: isMobile ? '1.1rem' : '1.5rem'
                  }}
                >
                  Incident Details
                </Typography>
              </Box>
              <Divider sx={{ mb: isMobile ? 2 : 3 }} />

              <Grid container spacing={isMobile ? 1 : 2}>
                <Grid item xs={12}>
                  <Controller
                    name="description"
                    control={mainForm.control}
                    render={({ field }) => (
                      <TextField
                        size="small"
                        label="Description of the Breach"
                        multiline
                        rows={isMobile ? 3 : 4}
                        fullWidth
                        margin="normal"
                        placeholder="Provide a detailed account of the breach"
                        {...field}
                        error={!!mainForm.formState.errors.description}
                        helperText={mainForm.formState.errors.description?.message as string}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Controller
                    name="individuals_affected"
                    control={mainForm.control}
                    render={({ field }) => (
                      <TextField
                        size="small"
                        label="Individuals Affected"
                        multiline
                        rows={isMobile ? 2 : 2}
                        fullWidth
                        margin="normal"
                        placeholder="e.g., Client: John Doe, Staff: Jane Smith"
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <FaUserCircle size={16} />
                            </InputAdornment>
                          )
                        }}
                        {...field}
                        error={!!mainForm.formState.errors.individuals_affected}
                        helperText={
                          mainForm.formState.errors.individuals_affected?.message as string
                        }
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Controller
                    name="contact_info"
                    control={mainForm.control}
                    render={({ field }) => (
                      <TextField
                        size="small"
                        label="Contact Information"
                        multiline
                        rows={isMobile ? 2 : 2}
                        fullWidth
                        margin="normal"
                        placeholder="e.g., Phone, Email of affected individuals"
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <FaUserCircle size={16} />
                            </InputAdornment>
                          )
                        }}
                        {...field}
                        error={!!mainForm.formState.errors.contact_info}
                        helperText={mainForm.formState.errors.contact_info?.message as string}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Controller
                    name="immediate_actions"
                    control={mainForm.control}
                    render={({ field }) => (
                      <TextField
                        size="small"
                        label="Immediate Actions Taken"
                        multiline
                        rows={isMobile ? 3 : 4}
                        fullWidth
                        margin="normal"
                        placeholder="e.g., Secured data, notified management"
                        {...field}
                        error={!!mainForm.formState.errors.immediate_actions}
                        helperText={mainForm.formState.errors.immediate_actions?.message as string}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Controller
                    name="photo"
                    control={mainForm.control}
                    render={({ field: { onChange, onBlur, ...field } }) => (
                      <Box>
                        <TextField
                          size="small"
                          label="Upload Photo"
                          type="file"
                          fullWidth
                          margin="normal"
                          inputRef={fileInputRef}
                          InputLabelProps={{ shrink: true }}
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <FaCamera size={16} />
                              </InputAdornment>
                            ),
                            inputProps: {
                              accept: 'image/*'
                            }
                          }}
                          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                            handlePhotoChange(e, onChange)
                          }
                          onBlur={onBlur}
                          error={!!mainForm.formState.errors.photo}
                          helperText={mainForm.formState.errors.photo?.message as string}
                        />
                        {photoPreview && isLargeScreen && (
                          <Box sx={{ mt: 1, textAlign: 'left' }}>
                            <Typography variant="subtitle2" sx={{ mb: 1 }}>
                              Photo Preview
                            </Typography>
                            <Box sx={{ position: 'relative', display: 'inline-block' }}>
                              <Avatar
                                src={photoPreview}
                                variant="rounded"
                                sx={{
                                  width: isMobile ? '100%' : 150,
                                  height: 150,
                                  objectFit: 'contain'
                                }}
                              />
                              <IconButton
                                size="small"
                                onClick={handleRemovePhoto}
                                sx={{
                                  position: 'absolute',
                                  top: -10,
                                  right: -10,
                                  bgcolor: theme.palette.error.main,
                                  color: theme.palette.common.white,
                                  '&:hover': {
                                    bgcolor: theme.palette.error.dark
                                  }
                                }}
                              >
                                <FiTrash size={16} />
                              </IconButton>
                            </Box>
                          </Box>
                        )}
                      </Box>
                    )}
                  />
                </Grid>
                {photoPreview && !isLargeScreen && (
                  <Grid item xs={12}>
                    <Box
                      sx={{ display: 'flex', justifyContent: isMobile ? 'center' : 'flex-start' }}
                    >
                      <Box sx={{ position: 'relative' }}>
                        <Avatar
                          src={photoPreview}
                          variant="rounded"
                          sx={{
                            width: isMobile ? '100%' : 150,
                            height: isMobile ? 150 : 150,
                            mt: isMobile ? 1 : 0,
                            objectFit: 'contain'
                          }}
                        />
                        <IconButton
                          size="small"
                          onClick={handleRemovePhoto}
                          sx={{
                            position: 'absolute',
                            top: -10,
                            right: -10,
                            bgcolor: theme.palette.error.main,
                            color: theme.palette.common.white,
                            '&:hover': {
                              bgcolor: theme.palette.error.dark
                            }
                          }}
                        >
                          <FiTrash size={16} />
                        </IconButton>
                      </Box>
                    </Box>
                  </Grid>
                )}
              </Grid>
            </Box>

            {/* Reporter Details */}
            <Box sx={{ mb: isMobile ? 3 : 4 }}>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  mb: isMobile ? 1 : 2,
                  pl: 1
                }}
              >
                <FaUserCircle
                  size={isMobile ? 16 : 20}
                  style={{
                    marginRight: 8,
                    color: theme.palette.primary.main
                  }}
                />
                <Typography
                  variant={isMobile ? 'h6' : 'h5'}
                  component="h2"
                  sx={{
                    fontWeight: 500,
                    fontSize: isMobile ? '1.1rem' : '1.5rem'
                  }}
                >
                  Reporter Details
                </Typography>
              </Box>
              <Divider sx={{ mb: isMobile ? 2 : 3 }} />

              <Grid container spacing={isMobile ? 1 : 2}>
                <Grid item xs={12} sm={6}>
                  <Controller
                    name="reporter_name"
                    control={mainForm.control}
                    render={({ field }) => (
                      <TextField
                        size="small"
                        label="Reporter's Full Name"
                        fullWidth
                        margin="normal"
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <FaUserCircle size={16} />
                            </InputAdornment>
                          )
                        }}
                        {...field}
                        error={!!mainForm.formState.errors.reporter_name}
                        helperText={mainForm.formState.errors.reporter_name?.message as string}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Controller
                    name="signature"
                    control={mainForm.control}
                    render={({ field }) => (
                      <TextField
                        size="small"
                        label="Signature"
                        fullWidth
                        margin="normal"
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <FaSignature size={16} />
                            </InputAdornment>
                          )
                        }}
                        {...field}
                        error={!!mainForm.formState.errors.signature}
                        helperText={mainForm.formState.errors.signature?.message as string}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Controller
                    name="date_completed"
                    control={mainForm.control}
                    render={({ field }) => (
                      <TextField
                        size="small"
                        label="Date Completed"
                        type="date"
                        fullWidth
                        margin="normal"
                        InputLabelProps={{ shrink: true }}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <FaCalendarAlt size={16} />
                            </InputAdornment>
                          )
                        }}
                        {...field}
                        error={!!mainForm.formState.errors.date_completed}
                        helperText={mainForm.formState.errors.date_completed?.message as string}
                      />
                    )}
                  />
                </Grid>
              </Grid>
            </Box>

            {/* Submit and Reset Buttons */}
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                gap: isMobile ? 2 : 3,
                mt: isMobile ? 3 : 4,
                mb: isMobile ? 1 : 0,
                flexDirection: isMobile ? 'column' : 'row'
              }}
            >
              <Button
                type="button"
                variant="outlined"
                color="secondary"
                size={isMobile ? 'medium' : 'large'}
                sx={{
                  px: isMobile ? 4 : 6,
                  py: isMobile ? 1 : 1.5,
                  fontSize: isMobile ? '0.9rem' : '1.1rem',
                  fontWeight: 600,
                  borderRadius: 2,
                  boxShadow: 1,
                  '&:hover': {
                    boxShadow: 3,
                    transform: 'translateY(-1px)'
                  },
                  transition: 'all 0.2s ease',
                  width: isMobile ? '100%' : 'auto'
                }}
                startIcon={<FaUndo size={isMobile ? 14 : 18} />}
                onClick={handleResetMain}
                disabled={!mainForm.formState.isDirty || loading}
              >
                Reset Form
              </Button>
              <Button
                type="submit"
                variant="contained"
                color="primary"
                size={isMobile ? 'medium' : 'large'}
                sx={{
                  px: isMobile ? 4 : 6,
                  py: isMobile ? 1 : 1.5,
                  fontSize: isMobile ? '0.9rem' : '1.1rem',
                  fontWeight: 600,
                  borderRadius: 2,
                  boxShadow: 1,
                  '&:hover': {
                    boxShadow: 3,
                    transform: 'translateY(-1px)'
                  },
                  transition: 'all 0.2s ease',
                  width: isMobile ? '100%' : 'auto'
                }}
                startIcon={<FaFileAlt size={isMobile ? 14 : 18} />}
                disabled={loading}
              >
                {loading ? <CircularProgress size={24} /> : 'Submit'}
              </Button>
            </Box>
          </form>
        )}

        {isFollowUpRoute && (
          <form onSubmit={followUpForm.handleSubmit(onSubmitFollowUp)}>
            {/* Follow-Up Actions */}
            <Box sx={{ mb: isMobile ? 3 : 4 }}>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  mb: isMobile ? 1 : 2,
                  pl: 1
                }}
              >
                <FaShieldAlt
                  size={isMobile ? 16 : 20}
                  style={{
                    marginRight: 8,
                    color: theme.palette.primary.main
                  }}
                />
                <Typography
                  variant={isMobile ? 'h6' : 'h5'}
                  component="h2"
                  sx={{
                    fontWeight: 500,
                    fontSize: isMobile ? '1.1rem' : '1.5rem'
                  }}
                >
                  Follow-Up Actions
                </Typography>
              </Box>
              <Divider sx={{ mb: isMobile ? 2 : 3 }} />

              <Grid container spacing={isMobile ? 1 : 2}>
                <Grid item xs={12}>
                  <FormControl component="fieldset" margin="normal" fullWidth>
                    <Typography
                      variant={isMobile ? 'subtitle2' : 'subtitle1'}
                      sx={{ mb: 1, pl: 1 }}
                    >
                      Was the Breach Reported Externally?
                    </Typography>
                    <Controller
                      name="breach_reported_externally"
                      control={followUpForm.control}
                      render={({ field }) => (
                        <RadioGroup
                          {...field}
                          onChange={(e) => field.onChange(e.target.value)}
                          sx={{
                            display: 'flex',
                            flexDirection: isMobile ? 'column' : 'row',
                            flexWrap: 'wrap',
                            gap: isMobile ? 0.5 : 1,
                            pl: 2
                          }}
                        >
                          <FormControlLabel
                            value="Yes"
                            control={<Radio size="small" color="primary" />}
                            label={
                              <Typography variant={isMobile ? 'body2' : 'body1'}>Yes</Typography>
                            }
                          />
                          <FormControlLabel
                            value="No"
                            control={<Radio size="small" color="primary" />}
                            label={
                              <Typography variant={isMobile ? 'body2' : 'body1'}>No</Typography>
                            }
                          />
                        </RadioGroup>
                      )}
                    />
                    {followUpForm.formState.errors.breach_reported_externally && (
                      <Typography color="error" variant="caption" sx={{ pl: 2 }}>
                        {followUpForm.formState.errors.breach_reported_externally.message as string}
                      </Typography>
                    )}
                  </FormControl>
                  {breach_reported_externally === 'Yes' && (
                    <Box sx={{ pl: isMobile ? 2 : 4, mt: 1 }}>
                      <Controller
                        name="reported_to"
                        control={followUpForm.control}
                        render={({ field }) => (
                          <TextField
                            size="small"
                            label="To Whom Was It Reported"
                            fullWidth
                            margin="normal"
                            placeholder="e.g., NDIS Commission, Police"
                            InputProps={{
                              startAdornment: (
                                <InputAdornment position="start">
                                  <FaUserCircle size={16} />
                                </InputAdornment>
                              )
                            }}
                            {...field}
                            error={!!followUpForm.formState.errors.reported_to}
                            helperText={
                              followUpForm.formState.errors.reported_to?.message as string
                            }
                          />
                        )}
                      />
                    </Box>
                  )}
                </Grid>
                <Grid item xs={12}>
                  <FormControl component="fieldset" margin="normal" fullWidth>
                    <Typography
                      variant={isMobile ? 'subtitle2' : 'subtitle1'}
                      sx={{ mb: 1, pl: 1 }}
                    >
                      Is the Incident Resolved?
                    </Typography>
                    <Controller
                      name="resolved"
                      control={followUpForm.control}
                      render={({ field }) => (
                        <RadioGroup
                          {...field}
                          onChange={(e) => field.onChange(e.target.value)}
                          sx={{
                            display: 'flex',
                            flexDirection: isMobile ? 'column' : 'row',
                            gap: isMobile ? 0.5 : 1,
                            pl: 2
                          }}
                        >
                          <FormControlLabel
                            value="Yes"
                            control={<Radio size="small" color="primary" />}
                            label={
                              <Typography variant={isMobile ? 'body2' : 'body1'}>Yes</Typography>
                            }
                          />
                          <FormControlLabel
                            value="No"
                            control={<Radio size="small" color="primary" />}
                            label={
                              <Typography variant={isMobile ? 'body2' : 'body1'}>No</Typography>
                            }
                          />
                        </RadioGroup>
                      )}
                    />
                    {followUpForm.formState.errors.resolved && (
                      <Typography color="error" variant="caption" sx={{ pl: 2 }}>
                        {followUpForm.formState.errors.resolved.message as string}
                      </Typography>
                    )}
                  </FormControl>
                </Grid>
                <Grid item xs={12}>
                  <Controller
                    name="prevention_recommendations"
                    control={followUpForm.control}
                    render={({ field }) => (
                      <TextField
                        size="small"
                        label="Recommendations for Prevention"
                        multiline
                        rows={isMobile ? 3 : 4}
                        fullWidth
                        margin="normal"
                        placeholder="Suggestions to prevent future breaches"
                        {...field}
                        error={!!followUpForm.formState.errors.prevention_recommendations}
                        helperText={
                          followUpForm.formState.errors.prevention_recommendations
                            ?.message as string
                        }
                      />
                    )}
                  />
                </Grid>
              </Grid>
            </Box>

            {/* Submit and Reset Buttons */}
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                gap: isMobile ? 2 : 3,
                mt: isMobile ? 3 : 4,
                mb: isMobile ? 1 : 0,
                flexDirection: isMobile ? 'column' : 'row'
              }}
            >
              <Button
                type="button"
                variant="outlined"
                color="secondary"
                size={isMobile ? 'medium' : 'large'}
                sx={{
                  px: isMobile ? 4 : 6,
                  py: isMobile ? 1 : 1.5,
                  fontSize: isMobile ? '0.9rem' : '1.1rem',
                  fontWeight: 600,
                  borderRadius: 2,
                  boxShadow: 1,
                  '&:hover': {
                    boxShadow: 3,
                    transform: 'translateY(-1px)'
                  },
                  transition: 'all 0.2s ease',
                  width: isMobile ? '100%' : 'auto'
                }}
                startIcon={<FaUndo size={isMobile ? 14 : 18} />}
                onClick={handleResetFollowUp}
                disabled={!followUpForm.formState.isDirty || loading}
              >
                Reset Form
              </Button>
              <Button
                type="submit"
                variant="contained"
                color="primary"
                size={isMobile ? 'medium' : 'large'}
                sx={{
                  px: isMobile ? 4 : 6,
                  py: isMobile ? 1 : 1.5,
                  fontSize: isMobile ? '0.9rem' : '1.1rem',
                  fontWeight: 600,
                  borderRadius: 2,
                  boxShadow: 1,
                  '&:hover': {
                    boxShadow: 3,
                    transform: 'translateY(-1px)'
                  },
                  transition: 'all 0.2s ease',
                  width: isMobile ? '100%' : 'auto'
                }}
                startIcon={<FaFileAlt size={isMobile ? 14 : 18} />}
                disabled={loading || !incidentId || alreadyFilled}
              >
                {loading ? <CircularProgress size={24} /> : 'Submit Follow-Up'}
              </Button>
            </Box>
          </form>
        )}
      </Paper>
    </Box>
  );
};

export default DataBreachIncidentForm;